import 'react-native-url-polyfill/auto';

import type { ImageSourcePropType } from 'react-native';

import AppManifest from '../common/AppManifest';
import development from './environment.development';
import developmentGlobalPremier from './environment.development-global-premier';
import developmentPlaybook from './environment.development-playbook';
import pat from './environment.pat';
import production from './environment.production';
import productionGlobalPremier from './environment.production-global-premier';
import productionPlaybook from './environment.production-playbook';
import staging from './environment.staging';
import stagingGlobalPremier from './environment.staging-global-premier';

export interface Environment {
  apiBaseUrl: string;
  socketUrl: string;
  webUrl: string;
  accessTokenKey: string;
  bearerPrefix: string;
  expires?: number;
  secure?: boolean;
  domain?: string;
  debug?: boolean;
  nutritionixAppId: string;
  nutritionixAppKey: string;
  withingsClientId: string;
  withingsRedirectUrl: string;
  fitbitWebClientId: string;
  fitbitAppClientId: string;
  fitbitRedirectWebUri: string;
  fitbitRedirectAppUri: string;
  privacyPolicyUrl: string;
  termsOfServiceUrl: string;
  hideInsurance: boolean;
  theme?: {
    logo?: ImageSourcePropType;
    loginLogo?: ImageSourcePropType;
    icon?: ImageSourcePropType;
    iconWhite?: ImageSourcePropType;
    organizationName?: string;
    appName?: string;
    placeHolder?: ImageSourcePropType;
    education?: {
      nutrition?: ImageSourcePropType;
      activity?: ImageSourcePropType;
      medical?: ImageSourcePropType;
      lifestyle?: ImageSourcePropType;
      smoking?: ImageSourcePropType;
      howTo?: ImageSourcePropType;
    };
    colors?: {
      primary?: string;
      primaryDark?: string;
      primaryLight?: string;
      primaryOutlineRestingBorder?: string;
      secondary?: string;
      accent?: string;
      link?: string;
    };
  };
  loginAgreements?: {
    termsOfService?: string;
    privacyPolicy: string;
    eula?: string;
  };
  localizationPatches?: {
    en: () => Promise<any>;
    es: () => Promise<any>;
  };
  navigation?: {
    careTeam?: boolean;
  };
  screens?: {
    medicationDetails?: {
      class?: boolean;
      prescriptionRefillReminder?: boolean;
      informationAndInteractionCards?: boolean;
    };
  };
  supportEmail?: string;
  iosAppLink?: string;
  androidAppLink?: string;
  videoCallProvider?: 'zoom' | 'twilio';
  zoomAppGroupId?: string;
}

export default (AppManifest.env === 'staging'
  ? staging
  : AppManifest.env === 'staging-global-premier'
    ? stagingGlobalPremier
    : AppManifest.env === 'development-playbook'
      ? developmentPlaybook
      : AppManifest.env === 'development-global-premier'
        ? developmentGlobalPremier
        : AppManifest.env.includes('production-playbook') // web, -firebase, -appstore derivatives
          ? productionPlaybook
          : AppManifest.env.includes('production-global-premier') // web, -firebase, -appstore derivatives
            ? productionGlobalPremier
            : AppManifest.env.includes('production') // web, -firebase, -appstore derivatives
              ? production
              : AppManifest.env.includes('pat') // web, -firebase, -appstore derivatives
                ? pat
                : development) as Environment;
